export const EVENT_CATEGORIES = [
  "Meetup",
  "Dinner",
  "Conference",
  "Hackathon",
  "Workshop",
  "Pitch",
  "Demo Day",
];

export const CATEGORY_STYLES = {
  Meetup: "text-sky-400 border-sky-500/30 bg-sky-500/10",
  Dinner: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  Conference: "text-brand border-brand/30 bg-brand/10",
  Hackathon: "text-violet-400 border-violet-500/30 bg-violet-500/10",
  Workshop: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  Pitch: "text-rose-400 border-rose-500/30 bg-rose-500/10",
  "Demo Day": "text-teal-400 border-teal-500/30 bg-teal-500/10",
};
